import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Pages.css';

const PrivacyPolicy = () => {
  return (
    <div className="App">
      <div className="background-gradient"></div>
      <div className="noise-overlay"></div>
      <div className="grid-overlay"></div>
      <Navbar />
      <div className="page-navigation">
        <Link to="/" className="back-link">← Back to Home</Link>
      </div>
      <main>
        <section className="page-section">
          <div className="page-container">
            <h1 className="page-title">Privacy Policy</h1>
            <div className="page-content">
              <p className="effective-date">Effective Date: May 1, 2025</p>
              
              <div className="policy-section">
                <h2>1. Introduction</h2>
                <p>
                  Welcome to StoryCape ("we," "our," or "us"). We are committed to protecting your privacy and ensuring you have a positive experience on our website and while using our services. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our SDK.
                </p>
                <p>
                  Please read this Privacy Policy carefully. By accessing or using our services, you acknowledge that you have read, understood, and agree to be bound by all the terms of this Privacy Policy and our Terms of Service.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>2. Information We Collect</h2>
                <h3>2.1 Information You Provide to Us</h3>
                <p>
                  We may collect information that you provide directly to us, including:
                </p>
                <ul>
                  <li>Contact information (such as name, email address, phone number, and company name)</li>
                  <li>Account credentials</li>
                  <li>Profile information</li>
                  <li>Payment information</li>
                  <li>Content you upload through our services</li>
                  <li>Communications with us</li>
                </ul>
                
                <h3>2.2 Information We Collect Automatically</h3>
                <p>
                  When you use our services, we may automatically collect certain information, including:
                </p>
                <ul>
                  <li>Device information (such as IP address, browser type, operating system)</li>
                  <li>Usage data (such as pages visited, time spent on pages, links clicked)</li>
                  <li>Location information</li>
                  <li>Cookies and similar technologies</li>
                </ul>
              </div>
              
              <div className="policy-section">
                <h2>3. How We Use Your Information</h2>
                <p>
                  We may use the information we collect for various purposes, including:
                </p>
                <ul>
                  <li>Providing, maintaining, and improving our services</li>
                  <li>Processing transactions and sending related information</li>
                  <li>Sending technical notices, updates, security alerts, and support messages</li>
                  <li>Responding to your comments, questions, and requests</li>
                  <li>Personalizing your experience</li>
                  <li>Monitoring and analyzing trends, usage, and activities</li>
                  <li>Marketing and advertising purposes</li>
                  <li>Detecting, investigating, and preventing fraudulent transactions and other illegal activities</li>
                  <li>Complying with legal obligations</li>
                </ul>
              </div>
              
              <div className="policy-section">
                <h2>4. Sharing of Information</h2>
                <p>
                  We may share your information with:
                </p>
                <ul>
                  <li>Service providers who perform services on our behalf</li>
                  <li>Business partners with whom we jointly offer products or services</li>
                  <li>Affiliates and subsidiaries</li>
                  <li>In response to legal process or when we believe it is necessary to comply with applicable law</li>
                  <li>To protect the rights, property, or safety of StoryCape, our users, or others</li>
                  <li>In connection with a merger, sale of company assets, financing, or acquisition</li>
                </ul>
              </div>
              
              <div className="policy-section">
                <h2>5. Your Choices</h2>
                <p>
                  You have several choices regarding the information we collect and how it is used:
                </p>
                <ul>
                  <li>Account Information: You may update, correct, or delete your account information at any time by logging into your account or contacting us</li>
                  <li>Cookies: Most web browsers are set to accept cookies by default. You can usually choose to set your browser to remove or reject cookies</li>
                  <li>Promotional Communications: You may opt out of receiving promotional emails from us by following the instructions in those emails</li>
                </ul>
              </div>
              
              <div className="policy-section">
                <h2>6. Data Security</h2>
                <p>
                  We take reasonable measures to help protect information about you from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>7. Children's Privacy</h2>
                <p>
                  Our services are not directed to children under 16, and we do not knowingly collect personal information from children under 16. If we learn we have collected personal information from a child under 16, we will delete that information.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>8. Changes to this Privacy Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time. If we make material changes, we will notify you by email or through our services, or by posting a notice on our website prior to the change becoming effective.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>9. Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                </p>
                <p>
                  Email: <a href="mailto:privacy@storycape.io">privacy@storycape.io</a><br />
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;